jQuery(document).ready(function () {
  setTimeout(function() { 
    jQuery('.add-to-cart').removeClass('d-none');
  }, 4000);

  /**
    var totalDiscount = 0;
    setTimeout(function () {
          if (jQuery(".money-template").length) {
              var tablehtml = jQuery(".money-template").html();
              jQuery("#PricingTable").html(tablehtml);
          }
          var orignalPrice  = 0;
          var orignalPriceTwo  = 0;
          var Fnfprice      = 0;
          var Proprice      = 0;
          var varientQty    = 0;
          var defaultPrice  = parseFloat(jQuery('.ctQuantityWrap .product__price').text().split('$')[1]);
          var minDisCount  = parseInt(jQuery("#PricingTable table.shappify_qb_grid tbody tr:nth-child(2) > td:first").text());
  
          jQuery(".PoloVariantQty .poloQty, .poloVairant .hatBtn, .PoloVariantQty .QtyBtnPlus, .poloVairant .hatQtyPlus, .PoloVariantQty .QtyBtnMinus, .poloVairant .hatQtyMinus").on("keyup click", function (index) {
            
              var varientQty   = 0;
              jQuery(".poloVairant .poloQty, .poloVairant .hatBtn").each(function () {
                  varientQty += parseInt(jQuery(this).val());
              })
            
              var varientPrice  = jQuery(this).parent('.js-qty__wrapper').parent('.product__quantity').parent('.varQty').parent('.ctQuantityWrap').find('.product__price').text(); 
              var currPrice     = parseFloat(varientPrice.split('$')[1]);
              if(varientQty >= minDisCount){
                    orignalPrice += currPrice * varientQty;
                    Fnfprice = orignalPrice;
               }
            
              if(varientQty >= 1){
                  orignalPriceTwo += defaultPrice * varientQty;
                  Proprice = orignalPriceTwo;
                
             }
              
              if(Fnfprice != 0){
                 totalDiscount = Proprice - Fnfprice;
                  var finaldisAmount = totalDiscount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
                  jQuery('.discountAmount').val(finaldisAmount);
             }
              orignalPrice     =  0;
              orignalPriceTwo  =  0;
              
          });
    }, 10000);
  
    setTimeout(function () {

        var selector = "[data-bunch-id]";
        var $bunches = jQuery(selector);
        var items = [];

        if ($bunches.length > 1) {
            var prevId = "";
            var mainPro = "";
            var mainProText = 0;
            var finalQty = 0;
            var mainProId = "";
            var subProId = "";
            var prevMainProid = "";
            var prevSubProid = "";
            var mainProKey = "";
            var subProKey = "";  
            var Fprice = 0;
            var finalPrice = 0;
            var formatPrice = '';
            $bunches.each(function () {
                var currId = jQuery(this).attr("data-bunch-id");
                var nextId = jQuery(this).attr("data-assets-id");

                if (currId !== prevId) {

                var lastBunchAssestId = $bunches.filter('[data-bunch-id="' + currId + '"]:nth-child(2)').attr('data-assets-id');
                $bunches.filter('[data-bunch-id="' + currId + '"]:last').attr('data-assets-id',lastBunchAssestId);
                $bunches.filter('[data-bunch-id="' + currId + '"]:first').attr('data-assets-id',lastBunchAssestId);
                $bunches.filter('[data-bunch-id="' + currId + '"]').not(":first").hide();
    
                  var itemsName = [];
                  jQuery('[data-bunch-id="' + currId + '"]').each(function(index) {
                    var itemName = jQuery(this).find('.LineItemName').text();
                    var itemValue = jQuery(this).find('.LineItemValue').text();
                    var itemCount = parseInt(jQuery(this).find('.LineItemBoxQty').text());
                    var itemPrice = jQuery(this).find('.LineItemBox .cart__price .money').text();
                    var itemFull =  '<div class="itemsMeta"><small>' + itemName + '</small></br>' + itemValue + '</div><div class="itemsMeta"><small>Price</small></br><span class="pricePerPeice">' + itemPrice + '</span></div><div class="itemsMeta"><small>Qty</small></br><span class="countPerPeice">' + itemCount + '</span></div>';
                  
                    var existingItem = itemsName.find(function(item) {
                        return item.includes(itemValue);
                    });
                  
                    if (existingItem) {
                        var existingCount = existingItem.split('<span class="countPerPeice">')[1];
                        var existingCountfinal = parseInt( existingCount.split('</span>')[0]);
                        var newCount = existingCountfinal + itemCount;
                        var updatedItem = '<div class="itemsMeta"><small>' + itemName + '</small></br>' + itemValue + '</div><div class="itemsMeta"><small>Price</small><br><span class="pricePerPeice">' + itemPrice + '</span></div><div class="itemsMeta"><small>Qty</small></br><span class="countPerPeice">' + newCount + '</span></div>';
                        itemsName[itemsName.indexOf(existingItem)] = updatedItem;
                    } else {
                        itemsName.push(itemFull);
                    }
                   
                  });
                  jQuery('[data-bunch-id]').filter('[data-bunch-id="' + currId + '"]:first').find('.finallineitemNames').html(itemsName);
          
                    $bunches.filter('[data-bunch-id="' + currId + '"]').not(":first").each(function () {
                            var lineItemBoxQty = parseInt(jQuery(this).find(".LineItemBoxQty").text());
                            finalQty += lineItemBoxQty;
                    });
                    mainProText = parseInt($bunches.filter('[data-bunch-id="' + currId + '"]:first').find(".LineItemBoxQty").text());   
                  
                    mainPro = mainProText + finalQty;

                    $bunches.filter('[data-bunch-id="' + currId + '"]:first').find(".LineItemBoxQty").text(mainPro);

                  jQuery('[data-bunch-id]').filter('[data-bunch-id="' + currId + '"]:first').find('.pricePerPeice').each(function () {
                      var mainPrice  = jQuery(this).text();
                      var mainQty    = parseInt(jQuery(this).parent('.itemsMeta').next('.itemsMeta').find('.countPerPeice').text());
                      var spiltPrice = parseFloat(mainPrice.split('$')[1]);
                      finalPrice  += spiltPrice * mainQty;
                      Fprice  = finalPrice;
                  });
                  formatPrice = Fprice.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
                  jQuery('[data-bunch-id]').filter('[data-bunch-id="' + currId + '"]:first').find('.LineItemTotal').text(formatPrice);
                  mainPro = 0;
                  mainProText = 0;
                  finalQty = 0
                  Fprice = 0;
                  finalPrice = 0;
                  formatPrice = '';
                }
                prevId = currId;
            });
Comment for customize app
            jQuery(".removeBtn").click(function () {
                var loader = jQuery(this).closest(".cart__item").css('filter','blur(1px)');
                var loader = jQuery(this).closest(".cart__item").find(".deleteLoader");
                loader.show();
                var bunchDelId = jQuery(this).attr("data-bunch-del-id");
                $bunches.filter('[data-bunch-id="' + bunchDelId + '"]').each(function () {
                    var mainProId = parseInt(jQuery(this).attr("data-bunch-id"));
                    var subProId = parseInt(jQuery(this).attr("data-assets-id"));

                    if (mainProId !== "" && !isNaN(mainProId) && mainProId !== prevMainProid) {
                        var mainProKey = jQuery(this).attr("data-key");
                        var mainProObj = {
                            id: mainProKey,
                            quantity: 0,
                        };
                        items.push(mainProObj);
                    }
                    prevMainProid = mainProId;
                    if (subProId !== "" && !isNaN(subProId) && subProId !== prevSubProid) {
                        var subProKey = jQuery(this).attr("data-key");
                        var subProObj = {
                            id: subProKey,
                            quantity: 0,
                        };
                        items.push(subProObj);
                    }
                    prevSubProid = subProId;
                });
                if (items.length !== 0) {
                    var index = 0;
                    var intervalId = setInterval(function () {
                        var data = items[index];
                        jQuery.ajax({
                            type: "POST",
                            url: "/cart/change.js",
                            data: data,
                            dataType: "json",
                            success: function (data) {
                            },
                            error: function (XMLHttpRequest, textStatus) {
                            },
                        });
                        index++;
                        if (index === items.length) {
                          setTimeout(function(){
                            loader.hide();
                            window.location.href = window.location.href;
                            clearInterval(intervalId);
                          },1000)
                        }
                    }, 700);
                }
            });
        } else {
            jQuery(".removeBtn").click(function () {
                var loader = jQuery(this).closest(".cart__item").find(".deleteLoader");
                loader.show();
                var bunchDelId = jQuery(this).attr("data-bunch-del-id");
                var singleProId = parseInt($bunches.filter('[data-bunch-id="' + bunchDelId + '"]').attr("data-key"));

                if (singleProId !== "" ) {
                    var singleProObj = {
                        id: singleProId,
                        quantity: 0,
                    };
                    items.push(singleProObj);
                }

                if (items.length !== 0) {
                        var data = items[0];
                        jQuery.ajax({
                            type: "POST",
                            url: "/cart/change.js",
                            data: data,
                            dataType: "json",
                            success: function (data) {
                                loader.hide();
                                window.location.href = window.location.href;
                            },
                            error: function (XMLHttpRequest, textStatus) {
                            },
                        });
                }
            });
        }
      jQuery('.mainCartLoader').fadeOut();
    }, 2000);
*/
    setTimeout(function () {
      if (jQuery('body').hasClass('template-cart') && jQuery("#CartPageForm .bold_csp_qb_savings").length) {
        var savings = jQuery("#CartPageForm .bold_csp_qb_savings div").text();
        jQuery('.savingAmount').html(savings);
      }
        var finalmaxQty;
        var finalmaxtr;
        var finalmaxprice;
        jQuery("#PricingTable table.shappify_qb_grid tbody tr:last").each(function () {
            finalmaxQty = parseInt(jQuery(this).find("td:nth-child(2)").text().split("+")[0]);
            finalmaxtr = jQuery(this).find("td:last");
            finalmaxprice = jQuery(this).find("td:last").text();
        });

        jQuery(".QtyBtnMinus , .QtyBtnPlus").on("click", function () {
            var SingleQuantChk = parseInt(jQuery(this).parent(".PoloVariantQty").find(".QtyBtn").val());
            var mainRow = jQuery(this).parent(".PoloVariantQty").parent(".product__quantity").parent(".varQty").parent(".ctQuantityWrap");
            if (SingleQuantChk > 0) {
                mainRow.find(".variant-input").find("input").prop("checked", true);
                mainRow.find(".variant-input").find(".variant__button-label").css("font-weight", "600");
            } else {
                mainRow.find(".variant-input").find("input").prop("checked", false);
                mainRow.find(".variant-input").find(".variant__button-label").css("font-weight", "400");
            }
            var inputVal = 0;
            jQuery(".poloVairant .QtyBtn").each(function () {
                inputVal += parseInt(jQuery(this).val());
            });
            var minQty = 0;
            var maxQty = 0;
            var currPrice = 0;
            var highlighttr = "";
            var highlighttrPrice = "";
            var lastVal = 0;
            var normalPrice = jQuery(".BoldChangeablePrice .product__price").text();
            var np = jQuery(".BoldChangeablePrice .product__price");
            jQuery("#PricingTable table.shappify_qb_grid tbody tr").each(function () {
                minQty = parseInt(jQuery(this).find("td:first").text());
                maxQty = parseInt(jQuery(this).find("td:nth-child(2)").text());
                currPrice = parseInt(jQuery(this).find("td:last").text());
                highlighttr = jQuery(this).find("td:last");
                highlighttrPrice = jQuery(this).find("td:last").text();
                if (inputVal >= finalmaxQty) {
                    np.text("");
                    highlighttr.css({ color: "black", background: "transparent" });
                    finalmaxtr.css({ color: "white", background: "black" });
                    np.text(finalmaxprice);
                } else {
                    if (inputVal >= minQty && inputVal <= maxQty) {
                        np.text("");
                        highlighttr.css({ color: "white", background: "black" });
                        np.text(highlighttrPrice);
                    } else {
                        highlighttr.css({ color: "black", background: "transparent" });
                    }
                }
            });
        });

        // jQuery(".disableCartBtn.enableInput").keyup(function () {
        //     var SingleQuantChk = parseInt(jQuery(this).parent(".PoloVariantQty").find(".QtyBtn").val());
        //     var mainRow = jQuery(this).parent(".PoloVariantQty").parent(".product__quantity").parent(".varQty").parent(".ctQuantityWrap");
        //     if (SingleQuantChk > 0) {
        //         mainRow.find(".variant-input").find("input").prop("checked", true);
        //         mainRow.find(".variant-input").find(".variant__button-label").css("font-weight", "600");
        //     } else {
        //         mainRow.find(".variant-input").find("input").prop("checked", false);
        //         mainRow.find(".variant-input").find(".variant__button-label").css("font-weight", "400");
        //     }
        //     var inputVal = 0;
        //     jQuery(".poloVairant .QtyBtn").each(function () {
        //         inputVal += parseInt(jQuery(this).val());
        //     });
        //     var minQty = 0;
        //     var maxQty = 0;
        //     var currPrice = 0;
        //     var highlighttr = "";
        //     var highlighttrPrice = "";
        //     var lastVal = 0;
        //     var normalPrice = jQuery(".BoldChangeablePrice .product__price").text();
        //     var np = jQuery(".BoldChangeablePrice .product__price");
        //     jQuery("#PricingTable table.shappify_qb_grid tbody tr").each(function () {
        //         minQty = parseInt(jQuery(this).find("td:first").text());
        //         maxQty = parseInt(jQuery(this).find("td:nth-child(2)").text());
        //         currPrice = parseInt(jQuery(this).find("td:last").text());
        //         highlighttr = jQuery(this).find("td:last");
        //         highlighttrPrice = jQuery(this).find("td:last").text();
        //         if (inputVal >= finalmaxQty) {
        //             np.text("");
        //             highlighttr.css({ color: "black", background: "transparent" });
        //             finalmaxtr.css({ color: "white", background: "black" });
        //             np.text(finalmaxprice);
        //         } else {
        //             if (inputVal >= minQty && inputVal <= maxQty) {
        //                 np.text("");
        //                 highlighttr.css({ color: "white", background: "black" });
        //                 np.text(highlighttrPrice);
        //             } else {
        //                 highlighttr.css({ color: "black", background: "transparent" });
        //             }
        //         }
        //     });
        // });
    }, 11000);


    setTimeout(function () {

        jQuery(".poloVairant .variant-input > input[type=radio]").on("change", function () {
            jQuery(this).siblings(".variant__button-label").css("font-weight", "600");
            jQuery(this).parent(".variant-input").parent(".variant-input-wrap").parent(".qtySlt").parent(".ctQuantityWrap").find(".varQty").find(".product__quantity").find(".PoloVariantQty").find(".QtyBtn").val("1");
        });
        jQuery(".bold_option_textbox input[type='text']").keypress(function () {
            if (jQuery(this).val().length >= 25) {
                jQuery(".maxLimitError").html('<span class="bold_option_value_price pl-0">Max character limit is 25.</span>');
                return false;
            } else {
                jQuery(".maxLimitError").html("");
            }
        });

        jQuery(".ctTollTipHide").hide();
        jQuery(".bold_option_value_title ~ .ctTooltipMain svg").hover(
            function () {
                jQuery(this).parent().find(".ctTollTipHide").fadeIn();
            },
            function () {
                jQuery(this).parent().find(".ctTollTipHide").fadeOut();
            }
        );

        jQuery(".chkOptOne").change(function () {
            jQuery(".secondLogofile").slideDown();
            jQuery(".secondLogoDigi").slideDown();
        });
        jQuery(".firstLogoRadio").change(function () {
            jQuery(".firstLogo").slideDown();
        });

        // jQuery('.poloVairant input[type=number][max]:not([max=""])').on('input', function(ev) {
        //   var $this = jQuery(this);
        //   var maxlength = $this.attr('max').length;
        //   var value = $this.val();
        //   if (value && value.length >= maxlength) {
        //     $this.val(value.substr(0, maxlength));
        //   }
        // });

        var inputQuantity = [];
        jQuery(".PoloVariantQty .QtyBtn").on("keyup", function (e) {
            var $field = jQuery(this),
                val = this.value,
                $thisIndex = parseInt($field.data("idx"), 10);
            if ((this.validity && this.validity.badInput) || isNaN(val) || $field.is(":invalid")) {
                this.value = inputQuantity[$thisIndex];
                return;
            }
            if (val.length > Number($field.attr("maxlength"))) {
                val = val.slice(0, 5);
                $field.val(val);
            }
            inputQuantity[$thisIndex] = val;
        });

        jQuery(".dummyAddToCart").click(function () {
         
            // validations
            if (jQuery(".firstLogoRadio:checked").length === 0) {
                jQuery(".requiredErrorfirst").html('<span class="bold_option_value_price pl-0">This is a required field!</span>');
                return false;
            }
            if (jQuery(".firstLogoRadio:checked").length !== 0) {
                if (jQuery(".firstLogofield").prop("files").length === 0) {
                    jQuery(".requiredErrorfirstLogo").html('<span class="bold_option_value_price pl-0">This is a required field!</span>');
                    return false;
                }
            }

            if (jQuery(".chkOptOne:checked").length !== 0) {
                if (jQuery(".SLFile").prop("files").length === 0) {
                    jQuery(".requiredErrorSLfile").html('<span class="bold_option_value_price pl-0">This is a required field!</span>');
                    return false;
                }
                if (jQuery(".secondLogoDigiinput:checked").length === 0) {
                    jQuery(".requiredErrorDigi").html('<span class="bold_option_value_price pl-0">This is a required field!</span>');
                    return false;
                }
            }
            if (jQuery(".ValidationChk").hasClass("colorOfthread")) {
                if (jQuery(".colorOfthread:checked").length === 0) {
                    jQuery(".requiredErrorColor").html('<span class="bold_option_value_price pl-0">This is a required field!</span>');
                    return false;
                }
            }
            if (jQuery(".digitizationFeeInputcheck").length !== 0){
              if (jQuery(".digitizationFeeInputcheck:checked").length === 0) {
                  jQuery(".requiredErrorthird").html('<span class="bold_option_value_price pl-0">This is a required field!</span>');
                  return false;
              }
            }
            // jQuery('.FormLoader').show();
            // jQuery('html, body').animate({
            //     scrollTop: $('.dummyAddToCart').offset().top
            // }, 2000);


          jQuery(this).addClass('btn--loading');
          
            jQuery('.product-single__meta').css({"filter":"blur(6px)", "pointer-events":"none"});
              if(totalDiscount != 0){
                var finaldisAmount = totalDiscount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
                jQuery('.discountAmount').val(finaldisAmount);
              }
            var inputVal = 0;
            jQuery(".poloVairant .QtyBtn").each(function () {
                inputVal += parseInt(jQuery(this).val());
            });
              console.log(inputVal);
            var items = [];
            var phTitle = jQuery("#phTitle").val();
            var phId = jQuery(".mainProductId").val();
              console.log('0');

            if (jQuery(".digitizationFeeInput").is(":checked") && jQuery(".digitizationFeeInput:checked").length !== 0) {
              console.log('3');
              
                var dId = jQuery(".digitizationFeeInput").attr("data-pid");
                let obj3 = {
                    id: dId,
                    quantity: 1,
                    properties: {
                        Product: phTitle,
                        Bunch_Id: phId,
                        ProId: dId,
                    },
                };
                items.push(obj3);
            }


          if (jQuery(".chkOptOne:checked").length !== 0) {
            if (jQuery(".SLFile").prop("files").length > 0) {
              console.log('4');
              
                var SLId = jQuery(".SLFile").attr("data-pid");
                let obj4 = {
                    id: SLId,
                    quantity: inputVal,
                    properties: {
                        Product: phTitle,
                        Bunch_Id: phId,
                        ProId: SLId,
                    },
                };
                items.push(obj4);
            }
          }
                    
          if (jQuery(".secondLogoDigiinputProduct").is(":checked") && jQuery(".secondLogoDigiinputProduct:checked").length !== 0) {
              console.log('9');
              
                var dId = jQuery(".secondLogoDigiinputProduct").attr("data-pid");
                let objDigi = {
                    id: dId,
                    quantity: 1,
                    properties: {
                        Product: phTitle,
                        Bunch_Id: phId,
                        ProId: dId,
                    },
                };
                items.push(objDigi);
            }

          if(jQuery(".cbm_1918522_745383").length !== 0){
              console.log('1');
              jQuery(".cbm_1918522_745383").each(function () {
                  if (jQuery(this).is(":checked")) {
                      var pid = jQuery(this).attr("data-pid");
                      let obj1 = {
                          id: pid,
                          quantity: inputVal,
                          properties: {
                              Product: phTitle,
                              Bunch_Id: phId,
                              ProId: pid,
                          },
                      };
                      items.push(obj1);
                  }
              });
            }

          if(jQuery(".poloQty").length !== 0){
              console.log('2');
            
            var variantVal = 0;
            var vid;
            var firstVariant = 1;
              jQuery(".poloVairant .poloQty").each(function (index) {
                  variantVal = parseInt(jQuery(this).val());
                  if (variantVal > 1) {
                      if (firstVariant == 1) {
                          --variantVal;
                          firstVariant++;
                      }
                      vid = jQuery(this).attr("data-pid");
                      let obj2 = {
                          id: vid,
                          quantity: variantVal,
                          properties: {
                              Product: phTitle,
                              Bunch_Id: phId,
                              ProId: vid,
                          },
                      };
                      items.push(obj2);
                  }
              });
            }

            // if (jQuery(".BoldTextfield").val() !== "") {
            //   var pid = jQuery(".BoldTextfield").attr("data-pid");
            //   var EngravingText = jQuery(".BoldTextfield").val();
            //   let obj5 = {
            //     id: pid,
            //     quantity: inputVal,
            //     properties: {
            //       Product: phTitle,
            //       Engraving: EngravingText,
            //       Bunch_Id: phId,
            //       ProId: pid
            //     },
            //   };
            //   items.push(obj5);
            // }

            var data = {
                items: items,
            };

            // if (jQuery(".BoldTextfield").length) {
            //   if (jQuery(".BoldTextfield").val() !== "") {
            //     if (inputVal > 1 && jQuery(".uf_1918518_745383").val !== "") {
            //       jQuery.ajax({
            //         type: "POST",
            //         url: "/cart/add.js",
            //         data: data,
            //         dataType: "json",
            //         success: function (data) {
            //           jQuery(".poloForm").submit();
            //         },
            //         error: function (jqXHR, textStatus, errorThrown) {
            //           console.log(jqXHR.responseJSON.description);
            //           console.log(textStatus);
            //           console.log(errorThrown);
            //         },
            //       });
            //     } else {
            //       jQuery(".requiredError").html(
            //         '<span class="bold_option_value_price pl-0">This is a required field!</span>'
            //       );
            //     }
            //   } else {
            //     if (inputVal > 1 && jQuery(".uf_1918518_745383").val !== "") {
            //       jQuery(".poloForm").submit();
            //     } else {
            //       jQuery(".requiredError").html(
            //         '<span class="bold_option_value_price pl-0">This is a required field!</span>'
            //       );
            //     }
            //   }
            // } else {

          console.log(data);
          if(data.items.length >= 1){
            console.log('ok');
            jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: data,
                dataType: "json",
                success: function (data) {
                    if (jQuery(".poloVairant .poloQty").length) {
                        jQuery(".poloVairant .poloQty").each(function (minusIndex) {
                            var nonZero = jQuery(this).val();
                            if (nonZero != 0) {
                                jQuery(this).val(nonZero - 1);
                                jQuery(".variantBox .variant-input input").each(function (compareIndex) {
                                    if (minusIndex == compareIndex) {
                                        jQuery(this).trigger("click");
                                        setTimeout(function () {
                                            // jQuery('.poloForm .add-to-cart').click();
                                            jQuery(".poloForm").submit();
                                        }, 2000);
                                    }
                                });
                                return false;
                            }
                        });
                    } else {
                        setTimeout(function () {
                            jQuery(".poloForm").submit();
                        }, 2000);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {

                },
            });

          }else{
            console.log('no ok');
            
             setTimeout(function () {
                  jQuery(".poloForm").submit();
              }, 2000);
          }
        // }
        });
    }, 2000);
});